import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { getRouteWithParam, ROUTES } from '../../../../constants/routes';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';
import { formatDate } from '../../../../utils/formatDate';
import { getBonusRecordColorStatus } from '../../constants/bonusRecordStatus';

export const BonusRecordTableBody = ({ data, permissions = {} }) => {
  const history = useHistory();
  const [tooltip, setTooltip] = useState(false);

  const tableRow = (component, key) => tooltip ?
    <Tooltip
      key={key}
      title={DISABLED_CONTROL_TOOLTIP}
      arrow data-testid="Tooltip"
    >{component}</Tooltip> :
    component;

  const navigateToBonusRecordDetail = (cardId) => history.push(getRouteWithParam(ROUTES.BONUS_RECORD_DETAIL, ':id', cardId));

  return (
    <TableBody data-testid="TableBody">
      {data?.map((card) => tableRow(
        <TableRow
          key={card.document_number}
          onClick={() => {
            permissions.retrieve ?
              navigateToBonusRecordDetail(card.id) :
              setTooltip(true);
          }}
          onMouseLeave={() => setTooltip(false)}
          sx={{ cursor: permissions.retrieve ? 'pointer' : 'default' }}
          data-testid="TableRow"
        >
          <TableCell>
            <Box>{formatDate(card.created_at, true)}</Box>
          </TableCell>
          <TableCell>
            <Box sx={{ whiteSpace: 'normal', wordWrap: 'break-all' }}>
              {card.document_number}
            </Box>
          </TableCell>
          <TableCell>
            <Box width="120px">{card.name || 'Иванов Дмитрий'}</Box>
          </TableCell>
          <TableCell>
            <Box>{card.customer_iin}</Box>
          </TableCell>
          <TableCell>
            <Box>{card.customer_id}</Box>
          </TableCell>
          <TableCell>
            <Box width="115px">{card.mobile_phone}</Box>
          </TableCell>
          <TableCell>
            <Box>{card.customer_account_id}</Box>
          </TableCell>
          <TableCell>
            <Box>{card.amount}</Box>
          </TableCell>
          <TableCell>
            <Box
              color={getBonusRecordColorStatus(card.transaction_status)}
              data-testid={`status ${card.transaction_status}`}
            >
              {card.transaction_status}
            </Box>
          </TableCell>
          <TableCell>
            <Box>{card.payment_transaction_id}</Box>
          </TableCell>
        </TableRow>,
        card.document_number
      ))}
    </TableBody>
  );
};

BonusRecordTableBody.propTypes = {
  data: PropTypes.array,
  permissions: PropTypes.object,
};
